import React, { Component } from 'react'
import { Tooltip } from '@material-ui/core'

import { EditableSelect } from '../../common/EditableComponents'
import { MenuItem } from '@material-ui/core'
import { getLinkIcon, MASTER_CATEGORY, MASTER_PRODUCT } from '../CommonUpdateCells'

export const MCStatusComponent = (props) => {
  const { value, options, data, colDef } = props
  const displayValue = options[value ? 1 : 0]

  const activeShop = data && data.shop && data.shop.active
  const deletedShop = data && data.shop && data.shop.deleted
  const orphaned = colDef.obj === 'CATEGORY' ? !data.parentCategoryId : !data.masterId
  const masterType = colDef.obj === 'CATEGORY' ? MASTER_CATEGORY : MASTER_PRODUCT
  let isParent = !!data.children

  const shouldHide =
    ((!activeShop || deletedShop) && !data.children) ||
    (orphaned && !isParent) ||
    (data.productType && data.productType == 'BUNDLE')
  let linkIcon = getLinkIcon(masterType, isParent, data, colDef.field)

  const handleIconOption = (event) => {
    if (props.onSyncChildEvent) {
      props.onSyncChildEvent(props, {
        icon: linkIcon.icon,
        title: linkIcon.title,
      })
    }
  }
  return (
    <div className="center-item-column">
      <div className="align-item-column-value">{displayValue}</div>

      <div style={{ float: 'right' }}>
        <Tooltip title={linkIcon.title}>
          <img
            className="icon-validation"
            alt=""
            src={linkIcon.icon}
            hidden={shouldHide}
            onClick={(event) => handleIconOption(event)}
          />
        </Tooltip>
      </div>
    </div>
  )
}

export class MCStatusEditor extends Component {
  state = { value: this.props.value }

  handleChange = (event) => {
    const value = event.target.value
    this.setState({ value })
  }
  afterGuiAttached = () => {}
  getValue = () => this.state.value
  destroy = () => {}

  render() {
    const { options } = this.props
    const { value } = this.state

    return (
      <div className="center-item-column">
        <div className="align-item-column-value">
          <EditableSelect
            editMode={true}
            material={false}
            name="active"
            onChange={(event) => this.handleChange(event)}
            value={!!value}
          >
            <MenuItem value={false}>{options[0]}</MenuItem>
            <MenuItem value={true}>{options[1]}</MenuItem>
          </EditableSelect>
        </div>
      </div>
    )
  }
}

export default {
  MCStatusComponent,
  MCStatusEditor,
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCStatusComponent.js